function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  width: 24,
  height: 60,
  rx: 2,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 12H59C60.1046 12 61 12.8954 61 14V58C61 59.1046 60.1046 60 59 60H25V12Z",
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 34,
  y: 33,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 34,
  y: 21,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 21,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 9,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 33,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 45,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 21,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 34,
  y: 45,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 45,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46,
  y: 33,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#6F66FD",
  strokeWidth: 2
});

var SvgNurseClientsIcon = function SvgNurseClientsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNurseClientsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NurseClientsIcon.cac3e7a1.svg";
export { ForwardRef as ReactComponent };